import React, { useContext } from 'react';
import { ExternalLinkContext } from './external-link-provider';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Paper, Box, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import { useDisclaimers } from '../../hooks/use-disclaimers';

const ExternalLinkDialog = () => {
  const { t } = useTranslation();
  const { disclaimers } = useDisclaimers();
  // Locale is obtained from the i18next plugin
  const { language: locale = 'en' } = useI18next();
  const context = useContext(ExternalLinkContext);

  if (!context) {
    throw new Error('MyComponent debe estar dentro de un ExternalLinkProvider');
  }

  const { externalLink, open, setOpen } = context;

  if (!open) return null;

  const externalLinksMessage = disclaimers.find((disclaimer) => disclaimer.name === 'externalLinks');    

  return (
    <Dialog open={open} onClose={() => setOpen(false)} style={{ padding: '0px', margin: '0px' }}>
      <Paper sx={{ borderRadius: '8px', border: 'none', maxHeight: '100vh', overflowY: 'auto', padding: '0px', margin: '0px' }}>
        <DialogTitle style={{ padding: '0px', margin: '0px', backgroundColor: '#382656' }}>
          <Box
            sx={{
              width: '100%',
              maxWidth: 662,
              height: '80px',
              maxHeight: 256,

              position: 'relative',

              backgroundSize: 'cover',
              backgroundColor: '#382656',
              backgroundPosition: 'center',

              borderRadius: '8px 8px 0px 0px',
            }}
          >
            <Typography
              variant="h5"
              color="white"
              fontWeight={700}
              sx={{
                position: 'absolute',
                bottom: '24px',
                left: '24px',
              }}
            >
              {t('externalLinks.title')}
            </Typography>
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                padding: 0,
                marginBottom: '8px',
                position: 'absolute',
                backgroundColor: 'white',
                top: '24px',
                right: '24px',
                '&:hover': {
                  backgroundColor: 'white',
                },
              }}
            >
              <CancelIcon fontSize="large" sx={{ color: '#282032' }} />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent style={{ paddingTop: '24px' }}>
          {externalLinksMessage?.enabled && externalLinksMessage?.forWeb ? (
            <Typography variant="body1" color="secondary.light" padding="0px" margin="0px" dangerouslySetInnerHTML={{ __html: externalLinksMessage[`text_${locale}`] }} />
          ) : (
            <Typography variant="body1" color="secondary.light" padding="0px" margin="0px">
              {t('externalLinks.description')}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>{t('cancel')}</Button>
          <Button
            onClick={() => {
              window.open(externalLink, '_blank');
              setOpen(false);
            }}
          >
            {t('continue')}
          </Button>
        </DialogActions>
      </Paper>
    </Dialog>
  );
};

export default ExternalLinkDialog;
